import auth from '@/plugins/auth'
import router, { constantRoutes, dynamicRoutes } from '@/router'
import { getRouters } from '@/api/menu'
import { listSettingRouter } from "@/api/setting/settingRouter";
import Layout from '@/layout/index'
import ParentView from '@/components/ParentView'
import InnerLink from '@/layout/components/InnerLink'

// 匹配views里面所有的.vue文件
const modules = import.meta.glob('./../../views/**/*.vue')

const usePermissionStore = defineStore(
  'permission',
  {
    state: () => ({
      routes: [],
      addRoutes: [],
      defaultRoutes: [],
      topbarRouters: [],
      sidebarRouters: [],
      routerList: [], // 动态路由扁平化列表
      settingRouterList: [], // 路由配置列表
    }),
    actions: {
      setRoutes(routes) {
        this.addRoutes = routes
        this.routes = constantRoutes.concat(routes)
      },
      setDefaultRoutes(routes) {
        this.defaultRoutes = constantRoutes.concat(routes)
      },
      setTopbarRoutes(routes) {
        this.topbarRouters = routes
      },
      setSidebarRouters(routes) {
        this.sidebarRouters = routes
      },
      setRouterList(defaultRoutes){
        function flatteningToList(inPutList, routers) {
          let insertList = (list, routers) => {
            routers.forEach((item) => {
              if ( item.children && item.children.length > 0 ) {
                insertList(list, item.children);
              }
              let newItem = JSON.parse(JSON.stringify(item));
              delete newItem.children;
              list.push(newItem);
            });
          };
          insertList(inPutList, routers);
        }

        let inputList = [];
        flatteningToList(inputList, defaultRoutes);
        this.routerList = inputList;
      },
      generateRoutes(roles) {
        return new Promise(resolve => {
          // 向后端请求路由数据
          getRouters().then(res => {
            const sdata = JSON.parse(JSON.stringify(res.data))
            const rdata = JSON.parse(JSON.stringify(res.data))
            const defaultData = JSON.parse(JSON.stringify(res.data))
            const sidebarRoutes = filterAsyncRouter(sdata)
            const rewriteRoutes = filterAsyncRouter(rdata, false, true)
            const defaultRoutes = filterAsyncRouter(defaultData)
            const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
            const getouters = router.getRoutes();
            asyncRoutes.forEach(route => { 
              router.addRoute(route)
             })
            router.getpath
            this.setRoutes(rewriteRoutes)
            this.setSidebarRouters(constantRoutes.concat(sidebarRoutes))
            this.setDefaultRoutes(sidebarRoutes)
            this.setTopbarRoutes(defaultRoutes)
            // 需要将查询得到的路由拍扁, 暂存一份, 方便设置动态首页
            this.setRouterList(defaultRoutes);
            resolve(rewriteRoutes)
          })
        })
      },
      querylistSettingRouter(){
        return new Promise(resolve => {
          listSettingRouter().then(res => {
            if(res?.code == 200){
              this.settingRouterList = res.data;
            }
            resolve(res)
          })
        })
      }
    }
  })

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  const settingRouterList = usePermissionStore().settingRouterList;
  return asyncRouterMap.filter(route => {
    const fSettingRouter = settingRouterList.find(f => f.menuId === route.menuId);
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if(route.meta?.title && route.meta?.title == "首页"){
      route.meta.affix = true;
    }
    if(fSettingRouter){
      route.meta.layoutType = fSettingRouter.layoutType;
      route.meta.isOpen = fSettingRouter.isOpen;
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else if (route.component === 'ParentView') {
        route.component = ParentView
      } else if (route.component === 'InnerLink') {
        route.component = InnerLink
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

/**
 * 过滤, 得到下级路由 (排除其他跳转或链接网站等链接)
 * @param childrenMap
 * @param lastRouter
 * @returns {*[]}
 */
function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions) || route.permissions.length == 0) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

export const loadView = (view) => {
  let res;
  for (const path in modules) {
    const dir = path.split('views/')[1].split('.vue')[0];
    if (dir === view) {
      res = () => modules[path]();
    }
  }
  return res;
}

export default usePermissionStore
